<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M0,3V17H20V3ZM17.62,4.78l-7.19,5-7.94-5ZM1.74,15.22V6.36l8.74,5.55,7.78-5.45v8.76Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
